export default function SupportText(props) {
  const { content } = props;
  return (
    <div>
      <span className="block mb-3 text-emphasis-medium">
        Texto de apoio para a questão
      </span>

      <div dangerouslySetInnerHTML={{ __html: content }}></div>
    </div>
  );
}
